// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as SupplierSelect from "../Supplier/SupplierSelect.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let Raw = {};

let query = Client.gql(["mutation updateVariant_supplier($id: ID!, $input: InputUpdateVariant!)  {\nupdateVariant(id: $id, input: $input)  {\n__typename  \nid  \nsupplier  {\n__typename  \nid  \n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.updateVariant;
  let value$2 = value$1.supplier;
  return {
    updateVariant: {
      __typename: value$1.__typename,
      id: value$1.id,
      supplier: !(value$2 == null) ? ({
          __typename: value$2.__typename,
          id: value$2.id
        }) : undefined
    }
  };
}

function serialize(value) {
  let value$1 = value.updateVariant;
  let value$2 = value$1.supplier;
  let supplier;
  if (value$2 !== undefined) {
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    supplier = {
      __typename: value$4,
      id: value$3
    };
  } else {
    supplier = null;
  }
  let value$5 = value$1.id;
  let value$6 = value$1.__typename;
  let updateVariant = {
    __typename: value$6,
    id: value$5,
    supplier: supplier
  };
  return {
    updateVariant: updateVariant
  };
}

function serializeInputObjectInputUpdateVariantMetaData(inp) {
  let a = inp.shopifyVariantId;
  return {
    shopifyVariantId: a !== undefined ? a : undefined
  };
}

function serializeInputObjectInputUpdateVariant(inp) {
  let a = inp.stockKeepingUnit;
  let a$1 = inp.name;
  let a$2 = inp.purchasedPrice;
  let a$3 = inp.year;
  let a$4 = inp.capacityValue;
  let a$5 = inp.capacityUnit;
  let a$6 = inp.capacityPrecision;
  let a$7 = inp.alcoholVolume;
  let a$8 = inp.ean13;
  let a$9 = inp.internalNote;
  let a$10 = inp.metadata;
  let a$11 = inp.tastingNote;
  let a$12 = inp.packaging;
  let a$13 = inp.internalCode;
  let a$14 = inp.priceLookUpCode;
  let a$15 = inp.supplierId;
  let a$16 = inp.minStockThreshold;
  let a$17 = inp.maxStockThreshold;
  let a$18 = inp.stockOrderTriggerThreshold;
  return {
    stockKeepingUnit: a !== undefined ? a : undefined,
    name: a$1 !== undefined ? a$1 : undefined,
    purchasedPrice: a$2 !== undefined ? a$2 : undefined,
    year: a$3 !== undefined ? a$3 : undefined,
    capacityValue: a$4 !== undefined ? a$4 : undefined,
    capacityUnit: a$5 !== undefined ? a$5 : undefined,
    capacityPrecision: a$6 !== undefined ? a$6 : undefined,
    alcoholVolume: a$7 !== undefined ? a$7 : undefined,
    ean13: a$8 !== undefined ? a$8 : undefined,
    internalNote: a$9 !== undefined ? a$9 : undefined,
    metadata: a$10 !== undefined ? serializeInputObjectInputUpdateVariantMetaData(a$10) : undefined,
    tastingNote: a$11 !== undefined ? a$11 : undefined,
    packaging: a$12 !== undefined ? a$12 : undefined,
    internalCode: a$13 !== undefined ? a$13 : undefined,
    priceLookUpCode: a$14 !== undefined ? a$14 : undefined,
    supplierId: a$15 !== undefined ? a$15 : undefined,
    minStockThreshold: a$16 !== undefined ? a$16 : undefined,
    maxStockThreshold: a$17 !== undefined ? a$17 : undefined,
    stockOrderTriggerThreshold: a$18 !== undefined ? a$18 : undefined
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id,
    input: serializeInputObjectInputUpdateVariant(inp.input)
  };
}

function makeVariables(id, input, param) {
  return {
    id: id,
    input: input
  };
}

function makeInputObjectInputUpdateVariant(stockKeepingUnit, name, purchasedPrice, year, capacityValue, capacityUnit, capacityPrecision, alcoholVolume, ean13, internalNote, metadata, tastingNote, packaging, internalCode, priceLookUpCode, supplierId, minStockThreshold, maxStockThreshold, stockOrderTriggerThreshold, param) {
  return {
    stockKeepingUnit: stockKeepingUnit,
    name: name,
    purchasedPrice: purchasedPrice,
    year: year,
    capacityValue: capacityValue,
    capacityUnit: capacityUnit,
    capacityPrecision: capacityPrecision,
    alcoholVolume: alcoholVolume,
    ean13: ean13,
    internalNote: internalNote,
    metadata: metadata,
    tastingNote: tastingNote,
    packaging: packaging,
    internalCode: internalCode,
    priceLookUpCode: priceLookUpCode,
    supplierId: supplierId,
    minStockThreshold: minStockThreshold,
    maxStockThreshold: maxStockThreshold,
    stockOrderTriggerThreshold: stockOrderTriggerThreshold
  };
}

function makeInputObjectInputUpdateVariantMetaData(shopifyVariantId, param) {
  return {
    shopifyVariantId: shopifyVariantId
  };
}

let SupplierIdMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData,
  makeVariables: makeVariables,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let SupplierIdMutation_useWithVariables = include.useWithVariables;

let SupplierIdMutation = {
  SupplierIdMutation_inner: SupplierIdMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData,
  makeVariables: makeVariables,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData,
  use: use,
  useWithVariables: SupplierIdMutation_useWithVariables
};

function CatalogSupplierTableEditCell(props) {
  let variantId = props.variantId;
  let mutate = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)[0];
  let onMutateSupplierRequested = React.useCallback(supplier => {
    let supplierId = Stdlib_Option.flatMap(supplier, supplier => Primitive_option.fromNullable(supplier.id));
    let input = makeInputObjectInputUpdateVariant(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, supplierId !== undefined ? supplierId : null, undefined, undefined, undefined, undefined);
    Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: variantId,
      input: input
    })), undefined, param => variantId);
  }, []);
  return JsxRuntime.jsx(SupplierSelect.make, {
    preset: {
      NAME: "inputField",
      VAL: {
        required: false
      }
    },
    defaultOpen: true,
    shopId: props.shopId,
    value: {
      id: props.supplierId,
      name: props.supplierName
    },
    onChange: onMutateSupplierRequested,
    onDismiss: props.onDismiss
  });
}

let make = React.memo(CatalogSupplierTableEditCell, (oldProps, newProps) => {
  if (oldProps.supplierId === newProps.supplierId && oldProps.variantId === newProps.variantId) {
    return oldProps.shopId === newProps.shopId;
  } else {
    return false;
  }
});

export {
  SupplierIdMutation,
  make,
}
/* query Not a pure module */
